import {Notification} from 'react-admin';

const MyNotification = (props: any) => <Notification {...props} autoHideDuration={5000} />;

export default MyNotification;
